
import Vue from 'vue';
import { mapActions, mapState, mapGetters } from 'vuex';
import AddBalanceFundsButton from '@/components/AddBalanceFundsButton.vue';
import { MyBalanceMixin, TeamUserMixin } from '@/mixins';
import ListItem from '@/components/base/ListItem.vue';
import _truncate from 'lodash/truncate';
import _isEmpty from 'lodash/isEmpty';
import RdBorderCardUpsell from '@/components/RdBorderCardUpsell.vue';
import { UPSELL_TYPE } from '@/constants/constants';
import SessionsHistoryDialog from '@/components/Toolbar/UserAccount/SessionsHistoryDialog.vue';
import PaymentsHistoryDialog from '@/components/Toolbar/UserAccount/PaymentsHistoryDialog.vue';
import { ROUTER } from '@/router/constants';
import GetSupportBtn from '@/components/Toolbar/GetSupportBtn/GetSupportBtn.vue';
import { RUNNITS_OWNER_SELECTION } from '@/views/Runnits/constants';

export default Vue.extend({
	name: 'BalanceDetailsDialog',
	mixins: [
		MyBalanceMixin,
		TeamUserMixin,
	],
	props: {
		value: { type: Boolean, default: false },
		showInsufficientTeamBalanceCallout: { type: Boolean, default: false },
	},
	data () {
		return {
			UPSELL_TYPE,
			sessionsHistoryDialogOpen: false,
			paymentsHistoryDialogOpen: false,
		};
	},
	computed: {
		...mapState([
			'realTimeMoment',
			'team',
			'user',
			'userBalanceAccount',
			'teamBalanceAccount',
			'runnitState',
		]),
		...mapGetters([
			'userClubOfferBenefits',
			'displayLabels',
		]),
		teamSelected () {
			return this.runnitState.runnitsOwnerSelection === RUNNITS_OWNER_SELECTION.TEAM;
		},
		company () {
			return this.team && typeof this.team.company !== 'string' ? this.team.company : null;
		},
	},
	methods: {
		...mapActions([
			'setUpsellDialog',
		]),
		_isEmpty,
		_truncate,
		onInput (val: boolean) {
			this.$emit('input', !!val);
		},
		doUpsellToCreatorClub () {
			this.setUpsellDialog({ creatorsClub: true });
		},
		doUpsellToTeamPlanNewTab () {
			window.open(this.$router.resolve({ name: ROUTER.COMPANY_DASHBOARD }).href, '_blank');
		},
	},
	components: {
		GetSupportBtn,
		SessionsHistoryDialog,
		PaymentsHistoryDialog,
		RdBorderCardUpsell,
		ListItem,
		AddBalanceFundsButton,
	},
});
